module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/cc0a95c792fdc42b2b381f34fcdd8a9c.png";